const importOrder = {
	"clientAccount": "Client Account",
	"orderPlacement": "Order Placement",
	"buyer": "Buyer",
	"buyersPreferredEstimatedArrival": "Buyer's Preferred ETA to DC",
	"category": "Category",
	"isPriorityPO": "Priority PO?",
	"onAdDate": "On Ad Date",
	"receiptedDate": "Date Receipted at DC",
	"dcPercentage": "DC %",
	"allocatedPercentage": "% Allocated",
	"retailPriceIncrease": "Retail Price Increase (Y)?",
	"secondaryOrderNumber": "Secondary Order Number",
	"paymentInfo": "Payment Info",
	"inspectionCertificate": "Inspection Certificate Required",
	"requiredIntoStoreHelperText": "The date you would like to receive the goods by",
	"currency": "Currency",
	"importOutstandingAmount": "Amount",
	"isContainsNaturalProducts": "Does item contain natural products eg Wood, etc?",
	"allocationStatus": "Allocation Status",
	"skus": "Number of SKUs",
	"isRetailPriceIncrease": "Retail Price Increase (Y)?",
	"articleNumber": "Article Number",
	"commodityDescription": "Commodity Description"
};

export { importOrder };